import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=b9497572&scoped=true&"
import script from "./Spinner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Spinner.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9497572",
  null
  
)

export default component.exports